
import React, { Component } from 'react';

export class RN extends Component {

    render() {
        return (
            <div>
                <h1 align='center'>Raus Nichts</h1>
                   <br />
                <p>This is a bot division that have made and maintain (used to) 4 discord bots that have been made using 3 different frameworks and programming languages, from javascript (discord.JS), c# (dsharp) and c++ (d++).</p>
                <h2 align="center">Links</h2>
                <ul>
                    <li><b>Website </b><a href='https://rausnichts.vercel.app'>https://rausnichts.vercel.app</a></li>
                    <li><b>Raus Nichts </b><a href='https://rausnichts.vercel.app/Bots/RausNichts'>https://rausnichts.vercel.app/Bots/RausNichts</a></li>
                    <li><b>Mankey </b><a href='https://rausnichts.vercel.app/Bots/mankey'>https://rausnichts.vercel.app/Bots/mankey</a></li>
                    <li><b>Omanyte </b><a href='https://rausnichts.vercel.app/Bots/Omanyte'>https://rausnichts.vercel.app/Bots/Omanyte</a></li>
                    <li><b>Traum </b><a href='https://rausnichts.vercel.app/Bots/traum'>https://rausnichts.vercel.app/Bots/traum</a></li>
                    <li><b>Traum </b><a href='https://traum-doc.vercel.app'>https://traum-doc.vercel.app</a></li>
                 
                </ul>
            </div>
        );
    }
}
